var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUploaded(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 24,
    r: 24,
    fill: "#E7F6EC"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24 35.25C30.2132 35.25 35.25 30.2132 35.25 24C35.25 17.7868 30.2132 12.75 24 12.75C17.7868 12.75 12.75 17.7868 12.75 24C12.75 30.2132 17.7868 35.25 24 35.25ZM28.5943 22.4218C29.1034 21.9555 29.1381 21.1649 28.6718 20.6557C28.2055 20.1466 27.4149 20.1119 26.9057 20.5782L22.2907 24.805L21.0943 23.7092C20.5852 23.243 19.7945 23.2777 19.3282 23.7868C18.8619 24.2959 18.8966 25.0866 19.4057 25.5529L21.4464 27.4218C21.9242 27.8594 22.6571 27.8594 23.1349 27.4218L28.5943 22.4218Z",
    fill: "#0F973D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUploaded);
export default __webpack_public_path__ + "static/media/uploaded.a2bb7c16506d15e5f339c6207eed81c9.svg";
export { ForwardRef as ReactComponent };